import React from 'react';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';

import MenuItem from '@hydra/common/components/MenuItem';
import Translate from '@hydra/common/components/i18n';
import Icon from '@hydra/common/components/Icon';
import { sendEvent } from '@hydra/utils/gtm';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  selected: {
    display: 'flex',
    marginRight: theme.spacing(1)
  },
  icon: {
    marginTop: theme.spacing(0.25),
    marginRight: theme.spacing(0.5)
  },
  item: {
    marginLeft: theme.spacing(0.5)
  }
}));

const getEventItem = ({ item, type }) => item.toLowerCase().replace(type, '');

export const FilterSelect = ({ icon, content, filterType, items, handleSelect, className }) => {
  const classes = useStyles();
  const selected = Object.keys(items).filter(item => items[item]);
  const handleChange = e => {
    const active = e.target.value.length > selected.length;
    const itemClicked = active
      ? e.target.value.find(el => selected.indexOf(el) < 0)
      : selected.find(el => e.target.value.indexOf(el) < 0);
    const eventItemClicked = getEventItem({ item: itemClicked, type: content });
    sendEvent(`review-filter-${content}-${eventItemClicked}-checkbox`, { active });
    const newItems = Object.keys(items).reduce((items, item) => {
      items[item] = e.target.value.includes(item);
      return items;
    }, {});
    return handleSelect({
      items: newItems,
      filterType
    });
  };
  return (
    <FormControl className={className}>
      <Select
        id={`filter-${content}`}
        value={selected}
        multiple
        displayEmpty
        renderValue={selected => (
          <div className={classes.selected}>
            <Icon type={icon} size='sm' className={classes.icon} />
            <Translate content={`filter_${content}`} />
            {selected.length > 0 && <span className={classes.item}>({selected.length})</span>}
          </div>
        )}
        onChange={handleChange}
        MenuProps={{ variant: 'menu' }}
        onOpen={() => sendEvent(`review-filter-${content}-dropdown`)}
      >
        {Object.keys(items).map((item, index) => (
          <MenuItem value={item} key={index}>
            <Checkbox checked={items[item]} />
            <Translate content={`criterion_${filterType}${index + 1}`} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default React.memo(FilterSelect);
